import * as Yup from 'yup';

export const usePaketeValidation = () => {
  const formValidation = Yup.object({
    name: Yup.string()
      .max(1000, 'Paketname darf höchstens 50 Zeichen lang sein'),
      duration: Yup.number()
      .positive('Dauer muss eine positive Zahl sein'),
      price: Yup.number()
      .positive('Preis muss eine positive Zahl sein'),
      servicesList: Yup.array()
      .min(1, 'At least one service must be added'),
      priceInDayOff:Yup.string(),
      longDescription: Yup.string(),
  });
  return {
    formValidation
  };
};
